import { axios } from "utils";

import { ADMIN_DIGITAL_AGRONOMIST_URL as endpoint } from "consts";

import { AdminCropMixComposerCommercialMixRequest, AdminCropMixComposerCommercialMixResponse, UpdateCropMixComposerCommercialMixesResponseBody } from "models";

export const exportCropMixComposerCommercialMixes = async ({ signal }: { signal: AbortSignal }): Promise<AdminCropMixComposerCommercialMixResponse[]> =>
  axios.get(`${endpoint}/crop-mix-composer/export-commercial-mixes`, { signal });

export const updateCropMixComposerCommercialMixes = async ({
  data,
  signal,
}: {
  data: AdminCropMixComposerCommercialMixRequest[];
  signal: AbortSignal;
}): Promise<UpdateCropMixComposerCommercialMixesResponseBody> => axios.post(`${endpoint}/crop-mix-composer/update-commercial-mixes`, { data }, { signal });
